import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import SpeakerIcon from '@src/assets/icons/speaker.svg';
import theme from '@src/styles/theme';
import { StyledApiTtsSttLaunchBanner } from './index.style';

const ApiTtsSttLaunchBanner = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledApiTtsSttLaunchBanner>
      <img src={SpeakerIcon} className="banner-icon" alt="" />
      <Box className="banner-text">
        <Typography
          variant={isMobile ? 'body-12-regular' : 'body-14-regular'}
          color={COLOR.label2[100]}
        >
          {t('apiTtsSttLaunchBanner')}{' '}
          <a
            href="https://help.vbee.vn/docs/thong-bao/ban-cap-nhat-thang-04-2026"
            target="_blank"
            rel="noopener noreferrer"
            className="banner-link"
          >
            {t('viewDetail')}
          </a>
        </Typography>
      </Box>
    </StyledApiTtsSttLaunchBanner>
  );
};

export default ApiTtsSttLaunchBanner;
